// 数字を旧数字に変換する関数
export const convertToOldJapaneseNumbers = (num) => {
  const oldNumbers = {
    1: "壱",
    2: "弐",
    3: "参",
    4: "四",
    5: "五",
    6: "六",
    7: "七",
    8: "八",
    9: "九",
    10: "十",
  };

  return oldNumbers[num] || num.toString();
};
